/**
 * NDG Event List — tri géographique côté client.
 *
 * Toggle : 1er clic → tri par proximité, 2e clic → restaure l'ordre original.
 * Coordonnées mises en cache 30 min dans localStorage.
 */

const CACHE_KEY = 'ndg_geo_coords';
const CACHE_TTL = 30 * 60 * 1000;

const i18n = window.ndgGeo?.i18n ?? {
	sortBtn:  'Sort by proximity',
	sorted:   '✓ Sorted by proximity',
	loading:  '…',
	denied:   'Geolocation denied or unavailable.',
};

function haversineKm( lat1, lng1, lat2, lng2 ) {
	const R    = 6371;
	const dLat = ( lat2 - lat1 ) * Math.PI / 180;
	const dLng = ( lng2 - lng1 ) * Math.PI / 180;
	const a    = Math.sin( dLat / 2 ) ** 2
		+ Math.cos( lat1 * Math.PI / 180 )
		* Math.cos( lat2 * Math.PI / 180 )
		* Math.sin( dLng / 2 ) ** 2;
	return R * 2 * Math.atan2( Math.sqrt( a ), Math.sqrt( 1 - a ) );
}

function getCachedCoords() {
	try {
		const raw = localStorage.getItem( CACHE_KEY );
		if ( ! raw ) return null;
		const { lat, lng, ts } = JSON.parse( raw );
		if ( Date.now() - ts > CACHE_TTL ) { localStorage.removeItem( CACHE_KEY ); return null; }
		return { lat, lng };
	} catch { return null; }
}

function setCachedCoords( lat, lng ) {
	try { localStorage.setItem( CACHE_KEY, JSON.stringify( { lat, lng, ts: Date.now() } ) ); }
	catch { /* storage plein */ }
}

function initGeoSort( section ) {
	const btn   = section.querySelector( '.ndg-evlist__geo-btn' );
	const label = btn?.querySelector( '.ndg-evlist__geo-label' );
	const list  = section.querySelector( '.ndg-evlist__list' );

	if ( ! btn || ! label || ! list || ! navigator.geolocation ) {
		btn?.closest( '.ndg-evlist__geo-bar' )?.remove();
		return;
	}

	// Ordre original sauvegardé pour le toggle
	const originalOrder = [ ...list.querySelectorAll( 'li' ) ];
	let isSortedByGeo   = false;

	function setActive( active ) {
		isSortedByGeo    = active;
		btn.classList.toggle( 'is-active', active );
		btn.setAttribute( 'aria-pressed', String( active ) );
		label.textContent = active ? i18n.sorted : i18n.sortBtn;
		btn.disabled      = false;
	}

	function applyGeoSort( uLat, uLng ) {
		const items = [ ...list.querySelectorAll( 'li[data-lat]' ) ];
		if ( ! items.length ) return;
		items.sort( ( a, b ) =>
			haversineKm( uLat, uLng, +a.dataset.lat, +a.dataset.lng ) -
			haversineKm( uLat, uLng, +b.dataset.lat, +b.dataset.lng )
		);
		items.forEach( item => list.appendChild( item ) );
		setCachedCoords( uLat, uLng );
		setActive( true );
	}

	function restoreOriginalOrder() {
		originalOrder.forEach( item => list.appendChild( item ) );
		setActive( false );
	}

	// Rechargement de page : coords en cache → tri silencieux
	const cached = getCachedCoords();
	if ( cached ) applyGeoSort( cached.lat, cached.lng );

	btn.addEventListener( 'click', () => {
		// Toggle : si déjà trié → restaurer
		if ( isSortedByGeo ) { restoreOriginalOrder(); return; }

		btn.disabled      = true;
		label.textContent = i18n.loading;

		navigator.geolocation.getCurrentPosition(
			( { coords } ) => applyGeoSort( coords.latitude, coords.longitude ),
			() => {
				label.textContent = i18n.denied;
				btn.disabled      = false;
				setTimeout( () => { label.textContent = i18n.sortBtn; }, 4000 );
			},
			{ timeout: 10_000, maximumAge: 60_000 }
		);
	} );
}

document.querySelectorAll( '.ndg-evlist[data-sort="geo"]' ).forEach( initGeoSort );
